module.exports = __webpack_public_path__ + "static/media/UploadBrand.5d4b4ea5.svg";